/**
 * The founder's connections: Shopify, Triple Whale, then Keys for any other service. Each stores its key encrypted and
 * never shows it again.
 */
import { useState } from 'react'
import { Empty, Notice, Section, StatusChip } from '../components/ui'
import { useLoad } from '../useLoad'
import { useFounder } from './context'
import { KeysSection } from './KeysSection'
import { ConnectedPanel, DisconnectAction, SHOPIFY_DISCONNECT_QUESTION, ShopifyConnected, TripleWhaleCard } from './panels'
import { ShopifySetup } from './SetupPage'

const STATUS: Record<string, [string, string]> = {
  connected: ['active', 'connected'],
  not_connected: ['pending', 'not connected'],
  error: ['manual', 'needs a fresh key'],
}

export function ConnectionsPage() {
  const f = useFounder()
  const conns = useLoad(() => f.api.connections(), [f.api])
  const [replacing, setReplacing] = useState<string | null>(null)
  const [justConnected, setJustConnected] = useState<string | null>(null)
  return (
    <>
      <div className="page-head">
        <div>
          <span className="crumb">{f.state.world.founder.name}</span>
          <h1>Connections</h1>
        </div>
      </div>
      <p className="aside page-sub">The services your app reads from. Keys are stored encrypted, reach your app and your computer, and are never shown again.</p>
      {conns.error && <Notice>We couldn't load your connections just now. Try again in a moment.</Notice>}
      {!conns.data && !conns.error && <Empty>One moment.</Empty>}
      {conns.data?.map((c) => {
        const [tone, label] = STATUS[c.status] ?? ['pending', c.status]
        const connected = c.status === 'connected' && replacing !== c.key
        return (
          <Section key={c.key} title={c.name} action={<StatusChip status={tone} label={label} />}>
            {c.key === 'triplewhale' ? (
              <TripleWhaleCard connection={c} shopifyConnected={conns.data?.some((x) => x.key === 'shopify' && x.status === 'connected') ?? false} onChange={conns.reload} />
            ) : c.key !== 'shopify' ? (
              <p className="aside">Connecting {c.name} here comes soon.</p>
            ) : connected ? (
              <ConnectedPanel
                onReplace={() => setReplacing(c.key)}
                actions={
                  <DisconnectAction
                    connectionKey="shopify"
                    name="Shopify"
                    question={SHOPIFY_DISCONNECT_QUESTION}
                    onDone={() => (setJustConnected(null), conns.reload())}
                  />
                }
              >
                <ShopifyConnected name={justConnected ?? c.detail ?? 'your store'} warnings={c.warnings} scopes={c.scopes} checkedAt={c.checkedAt} onChecked={conns.reload} />
              </ConnectedPanel>
            ) : (
              <ShopifySetup
                connection={c}
                onConnected={(name) => {
                  setJustConnected(name)
                  setReplacing(null)
                  conns.reload()
                }}
              />
            )}
          </Section>
        )
      })}
      <KeysSection />
    </>
  )
}
